import React, { useEffect, useState } from 'react';
import '@/assets/app/css/chapter.css';
import levelBg from '@/assets/app/images/mypage/level_bg.png';
import ImgHeaderLevel from '@/assets/app/images/common/header/header-level.png';
import useAppAuthStore from '@/shared/store/UseAppAuthStore';
import TitleHeader from '../common/TitleHeader';
import { useNavigate } from 'react-router';
import { getUploadsUrl } from '@/shared/utils/CommonUtil';
import { HEADER_ICON_WIDTH } from '@/shared/constants/AppIcon';

interface Props {
  onBack?: () => void;
}

const Level: React.FC<Props> = ({ onBack }) => {
  const { member } = useAppAuthStore();
  const navigate = useNavigate();

  return (
    <>
      <div className="flex flex-col h-screen bg-white">
        <TitleHeader title="나의 씨앗별" onBack={() => navigate(-1)} />

        <main className="flex-1 p-4 flex items-start justify-center">
          <div
            className="w-full relative rounded-[40px] overflow-hidden"
            style={{
              backgroundImage: `url(${levelBg})`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              aspectRatio: '308 / 436',
            }}
          >
            {/* 레벨 배지 */}
            <div
              className="absolute top-6 left-6 status-item"
              style={{ backgroundColor: '#E2F1FB' }}
            >
              <img src={ImgHeaderLevel} width={HEADER_ICON_WIDTH.level} alt="level" className="status-icon" />
              <div className="status-text level">
                <span className="status-label">Lv.</span>
                <span className="status-value">{member?.level}</span>
              </div>
            </div>

            <div
              className="absolute left-1/2 -translate-x-1/2 flex flex-col items-center z-10"
              style={{ bottom: '80px' }} // ✅ 배경 하단에서 50px 띄움
            >
              <img
                src={`${getUploadsUrl()}${member?.levelImageFilename.replace('/uploads', '')}`}
                className="object-contain"
              />
            </div>

            {/* 바닥 언덕 (CSS로 구현하거나 이미지 처리) */}
          </div>
        </main>
      </div>
    </>
  );
};

export default Level;
